import * as types from '../actions/action-types';

const getInitialState = () => ({
  form: {},
  appliedGiftcards: [],
  message: null,
});

const giftcardReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case types.UPDATE_GIFTCARD_FORM:
      return {
        ...state,
        form: {
          ...state.form,
          [action.fieldName]: action.value,
        },
      };
    case types.CLEAR_GIFTCARD_FORM:
      return {
        ...state,
        form: {
          ...state.form,
          giftcardNumber: '',
          giftcardPin: '',
        },
      };
    case types.ADD_APPLIED_GIFTCARD_TO_STATE:
      return {
        ...state,
        appliedGiftcards: action.updatedAppliedGiftcards,
      };
    case types.SET_GIFTCARD_MESSAGE:
      return {
        ...state,
        message: action.message,
      };
    default:
      return state;
  }
};

export default giftcardReducer;
